module.exports = __webpack_public_path__ + "img/ibeacon-map.133e5630.jpg";